import type { MouseEvent } from 'react';
import { useFavorites } from '@/hooks/useFavorites';

interface FavoriteButtonProps {
  id: string;
  className?: string;
  showLabel?: boolean;
}

export default function FavoriteButton({ id, className = '', showLabel }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(id);

  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(id);
  };

  if (showLabel) {
    return (
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
          active
            ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
            : 'bg-background-100 text-foreground-800 border border-background-200 hover:border-primary-300 hover:text-primary-600'
        } ${className}`}
      >
        <i className={active ? 'ri-bookmark-fill text-base' : 'ri-bookmark-line text-base'} />
        {active ? '已收藏' : '收藏文章'}
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label={active ? '取消收藏' : '收藏'}
      className={`w-8 h-8 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
        active
          ? 'text-primary-500'
          : 'text-foreground-400 hover:text-primary-500'
      } ${className}`}
    >
      <i className={active ? 'ri-bookmark-fill text-lg' : 'ri-bookmark-line text-lg'} />
    </button>
  );
}